const routes = [
  {
    path: "/client_settings/:id/:settings_key/:sub_settings_key",
    component: () => import("@/views/app/pages/client_settings/distributor")
  },
  {
    path: "/client_settings",
    component: () => import("@/views/app/pages/client_settings")
  }
];

export default routes;
